export default "__VITE_ASSET__B4n$fN3E__"